/* eslint-disable */
// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import kontakt from './routes/kontakt';
import templateLandingPage from './routes/kontakt';
import singleHouse from './routes/singleHouse';
import { tns } from 'tiny-slider/src/tiny-slider';
import templateConfigurator from './routes/templateConfigurator';
import oNas from './routes/oNas';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,

  kontakt,

  singleHouse,

  templateLandingPage,

  templateConfigurator,

  oNas,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

window.addEventListener('DOMContentLoaded', () => {

  // mobile nav

  const hamburger = document.querySelector('#nav__hamburger');
  const header = document.querySelector('#header');
  const htmlEl = document.querySelector('html');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('nav__hamburger--active');
    header.classList.toggle('header--active');
    htmlEl.classList.toggle('html--locked');
  })

  window.addEventListener('scroll', () => {
    if (window.scrollY > 30 && !header.classList.contains('header--scrolled')) {
      header.classList.add('header--scrolled');
    } else if (window.scrollY <= 30) {
      header.classList.remove('header--scrolled');
    }
  })

  // sidebar icons

  const icons = Array.from(document.querySelectorAll('.sidebar-menu__icon'));

  if (icons) {
    icons.forEach(icon => {

      icon.addEventListener('mouseover', () => {
        icon.style.width = icon.querySelector('.sidebar-menu__text').scrollWidth + 35 + 'px';
      })
      icon.addEventListener('mouseleave', () => {
        if (window.scrollY > 30) {
          icon.style.width = '37px';
        }
      })

      window.addEventListener('scroll', () => {
        if (window.scrollY > 30) {
          icon.style.width = '37px';
        } else {
          icon.style.width = icon.querySelector('.sidebar-menu__text').scrollWidth + 35 + 'px';
        }
      })
    })
  }

  // slider

  const slider = document.querySelector('.slider');

  if (slider) {
    const tnsSlider = tns({
      container: '.slider',
      items: 1,
      nav: false,
      controlsContainer: '.slider-controls__container',
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayButtonOutput: false,
      responsive: {
        992: {
          items: 2,
          gutter: 20
        },
        1480: {
          items: 3,
        }
      }
    })
  }

  // hero background slider

  const heroSlider = document.querySelector('#hero__slider');

  if (heroSlider) {
    const tnsHeroSlider = tns({
      container: '.hero__slider',
      items: 1,
      mode: 'gallery',
      speed: 3200,
      nav: false,
      controls: false,
      autoplay: true,
      autoplayButtonOutput: false,
      autoplayTimeout: 8000,
    })
  }

  const sliderLightbox = document.querySelector('#slider-lightbox');
  const sliderImages = Array.from(document.querySelectorAll('.slide-wrapper'));
  const sliderLightboxClose = document.querySelector('#slider-lightbox__close');
  const sliderLightboxContainer = document.querySelector('#slider-lightbox__images-container');
  let insideSlider;

  if (sliderLightboxContainer) {
    insideSlider = tns({
      container: '.slider-lightbox__images-container',
      items: 1,
      nav: false,
      controlsContainer: '.slider-lightbox__nav',
    })
  }

  if (sliderImages) {
    sliderImages.forEach(image => {
      image.addEventListener('click', () => {
        sliderLightbox.style.display = 'flex';
        insideSlider.goTo(image.dataset.index);
        htmlEl.classList.add('html--locked');
      })
    })
  }

  if (sliderLightboxClose) {
    sliderLightboxClose.addEventListener('click', () => {
      sliderLightbox.style.display = 'none';
      htmlEl.classList.remove('html--locked');
    })
  }

  const templateLightbox = document.querySelector('#template-lightbox');
  const templateLightboxImage = document.querySelector('#template-lightbox__image');
  const templateLightboxClose = document.querySelector('#template-lightbox__close');
  const templatePhotos = Array.from(document.querySelectorAll('.content-section__image'));

  if (templatePhotos) {
    templatePhotos.forEach(photo => {
      photo.addEventListener('click', () => {
        templateLightbox.style.display = 'flex';
        templateLightboxImage.src = photo.src;
      })
    })

    if (templateLightboxClose) {
      templateLightboxClose.addEventListener('click', () => {
        templateLightbox.style.display = 'none';
      })
    }
  }

  const cookies = document.querySelector('#cookies');
  const cookiesButton = document.querySelector('#cookies__button');

  if (!document.cookie.includes('cookiesAcceptance=true') && cookies) {
    cookies.style.display = 'block';
  }

  cookiesButton.addEventListener('click', () => {
    cookies.style.bottom = `-${cookies.scrollHeight}px`;
    setTimeout(() => {
      cookies.style.display = 'none';
    }, 400);
    document.cookie = 'cookiesAcceptance=true; path=/; max-age=' + (30 * 24 * 60 * 60);
  })
  
})


// WEBPACK FOOTER //
// ./scripts/main.js